import { render, staticRenderFns } from "./agreementDetails.vue?vue&type=template&id=e94b2144&scoped=true"
import script from "./agreementDetails.vue?vue&type=script&lang=js"
export * from "./agreementDetails.vue?vue&type=script&lang=js"
import style0 from "./agreementDetails.vue?vue&type=style&index=0&id=e94b2144&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94b2144",
  null
  
)

export default component.exports